import {createStore} from 'vuex'

export default createStore({
    state: {
        leftTreeToHeaderTab: [{
            name: "Home",//组件的名称
            label: "首页",//组件在头部显示的tab名字
            linkTo: "/Home",//目前无作用
            query:null,//传递给组件的值
        },
        //     {
        //     name: "Jsjb_handInput",
        //     label: "工单录入",
        //     linkTo: "/Jsjb_handInput",
        //     query:null,
        // }
        ],//左侧树和头部tab之间的关联
        headerActiveTab:"首页",
        addNewWorkorderSuccess:false,
        token:"",
        addressName:"",//地图上选择的地址,
        afcsMapVal:"",
        afpqMapVal:"",
        isZybjIn:false,
        lnglat:[],
        wgsjSearchHight:"",//网格事件工单搜索模块的高度
        addMapSignTree:false,//增加 签到和地图左侧树
        inputBtnShow:false,//录入按钮显隐
        gdlxSelectedGeneralEvents:false,//录入工单类型
        gdxgRefreshData:false,//工单修改后刷新工单详情页面（工单处置、工单流程）数据
    },
    mutations: {
        addLeftTreeToHeaderTab(state, n) {
            for(var i=0;i<state.leftTreeToHeaderTab.length;i++){
                if(state.leftTreeToHeaderTab[i].label==n.label){
                    // state.headerActiveTab=n.label;
                    // if(i==0){
                    //     return
                    // }
                    // var openCurrent=state.leftTreeToHeaderTab.splice(i, 1);
                    // state.leftTreeToHeaderTab.splice(1, 0, openCurrent[0]);
                    state.headerActiveTab=n.label;
                    return
                }
            }
            state.headerActiveTab=n.label;
            // state.leftTreeToHeaderTab.splice(1, 0, n);
            state.leftTreeToHeaderTab.push(n)
        },
        deletLeftTreeToHeaderTab(state, n) {
            for(var i=0;i<state.leftTreeToHeaderTab.length;i++){
                if(state.leftTreeToHeaderTab[i].label==n){
                    state.leftTreeToHeaderTab.splice(i, 1);
                    return
                }
            }
        },
        headerActiveTabChange(state, n){
            state.headerActiveTab=n;
        }
    },
    actions: {},
    modules: {}
})
